import axiosInstance from '@/plugins/axios';

export const STATUS_LABEL = {
  REGULAR: 'Regular',
  IRREGULAR: 'Irregular',
  INDISPONIVEL: 'Indisponível',
};

// Tipo de certidão (CON-5284) — padrão da Certidão Federal. Deriva do texto do agnaldo no BFF.
export const TIPO_LABEL = {
  CND: 'CND',
  CPEN: 'CPEN',
  CP: 'CP',
  INDISPONIVEL: 'Indisponível',
};

const ServiceCndt = {
  sincronizar: (cnpj) => axiosInstance.post('cndt/sincronizar', { cnpj }),
  search: (body) => axiosInstance.post('cndt/search', body),
  dashboard: () => axiosInstance.get('cndt/dashboard'),
  salvar: (body) => axiosInstance.post('cndt', body),
  atualizar: (id, body) => axiosInstance.put(`cndt/${id}`, body),
  excluir: (id) => axiosInstance.delete(`cndt/${id}`),
  historico: (id, body) => axiosInstance.post(`cndt/${id}/historico`, body),
  // Export: enfileira um export persistido (report_process) — não retorna binário.
  exportData: (body) => axiosInstance.post('cndt/export', body ?? {}),
  downloadUrl: (key) => axiosInstance.get(`storage/download-url?key=${encodeURIComponent(key)}`),
  uploadArquivo: (file, key) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('key', key);
    return axiosInstance.post('storage/upload', fd);
  },
};

export default ServiceCndt;
